import React from "react";
import { useNavigate } from "react-router-dom";
import { getToken } from "../services/tokenService";

const NotFound = () => {
  const navigate = useNavigate();

  const token = getToken();

  const handleRedirect = () => {
    if (token) {
      navigate("/voucher");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="primary_bg fit_box">
      <div className="card" style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "60px" }}>404</h1>

        <h2>Page Not Found</h2>

        <p>The page you are looking for does not exist.</p>

        <button onClick={handleRedirect}>
          {token ? "Go to Voucher" : "Go to Login"}
        </button>
      </div>
    </div>
  );
};

export default NotFound;